import React from 'react';
import FormTextContainer from '../../../redux/containers/FormTextContainer';

const AboutYou = () =>
  <section>
    <div className="container">
      <div className="row">
        <div className="col-xs-12">
          <h3 className="half-charcoal">About You</h3>
          <p>Pop in your details below</p>
        </div>
      </div>
      <div className="row">
        <div className="col-sm-6">
          <FormTextContainer
            name="firstName"
            label="First name"
            placeholder="First name"
            autotestClass="autotest-first-name"
            maxLength={40}
            required
          />
        </div>
        <div className="col-sm-6">
          <FormTextContainer
            name="lastName"
            label="Last name"
            placeholder="Last name"
            autotestClass="autotest-last-name"
            maxLength={40}
            required
          />
        </div>
      </div>
      <div className="row">
        <div className="col-sm-6">
          <FormTextContainer
            name="email"
            label="Email"
            placeholder="Email"
            autotestClass="autotest-email"
            maxLength={80}
            required
          />
        </div>
        <div className="col-sm-6">
          <FormTextContainer
            name="contactNumber"
            label="Contact number"
            placeholder="Contact number"
            autotestClass="autotest-contact-number"
            maxLength={14}
            required
          />
          <small>
            This number will be used to contact you if we have trouble
            delivering your order.
          </small>
        </div>
      </div>
      <p className="section-half-margin">
        If you or someone in your household is vulnerable due to medical,
        disability or security reasons, you can apply to be added to our
        Vulnerable Consumer Register. This will ensure the vulnerable person is
        not unduly placed at risk when connecting, disconnecting, maintaining,
        or repairing faults with their Skinny services. You'll need to download
        and complete a Vulnerable Consumer form, after you have completed your
        Broadband sign up. For more information visit{' '}
        <a
          href="https://www.skinny.co.nz/vulnerable"
          target="_blank"
          rel="noopener noreferrer"
        >
          www.skinny.co.nz/vulnerable
        </a>
      </p>
    </div>
  </section>
;

export default AboutYou;



/** WEBPACK FOOTER **
 ** ./src/components/checkout/AboutYou/AboutYou.js
 **/